import * as types from './mutations-types'

export default {
  [types.SET_COMPETENCIA] : (state,obj)=>{
    state.competencia = obj.competencia
  },
  [types.SET_CENTRO_CUSTO] : (state,obj)=>{
    state.centroCusto = obj.centroCusto
  },
  [types.SET_TO_UPDATE] : (state,obj)=>{
    state.toUpdate = obj.state
  }

}



// WEBPACK FOOTER //
// ./src/features/Competencia/store/mutations.js